export default {
  tokenName: 'access_token'
}
